import moment from 'moment';
import React, { useMemo } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { isWeekendByLocale } from '../../components/shared/utils';

const isWeekend = (locale, date) => {
    const day = date.day(); // 0 = Sunday, 1 = Monday, ..., 5 = Friday, 6 = Saturday
    const isIsraelLocale = locale === 'he-IL' || locale === 'he';
    if (isIsraelLocale) {
        // Israel: weekends are Friday (5) and Saturday (6)
        return day === 5 || day === 6;
    } else {
        // Western countries: weekends are Saturday (6) and Sunday (0)
        return day === 6 || day === 0;
    }
};

const ResourceDayCell = ({ date, hotelId, viewSettings, yieldData, dateParameters, availabilityData }) => {
    const yieldForDate = yieldData?.find(y => y.HotelId == hotelId && moment(date).isSame(moment(y.Date), 'day'));
    const dateParam = dateParameters?.find(d => d.HotelId == hotelId && moment(date).isSame(moment(d.Date), 'day'));
    const availabilityForDate = availabilityData?.find(a => a.HotelId == hotelId && moment(date).isSame(moment(a.Date), 'day'));
    
    const locale = window.user?.UserSettings?.[0]?.Language?.Code || 'en';
    const isWeekendDay = useMemo(() => isWeekendByLocale(locale, date), [locale, date]);
    const className = useMemo(() => `resource-group-lane-day${isWeekendDay ? ' weekend' : ''}`, [isWeekendDay]);
    
    return (
        <div key={date.format('MM-DD')} className={className}>
            {
                dateParam && <div className='date-parameters'>
                    {viewSettings.showHoliday && dateParam.Event && <div className='holiday'>
                        <Popup trigger={<Icon name='star' />} content={dateParam.Event} />
                    </div>}
                    {viewSettings.showComments && dateParam.Notes && <div className='notes'>
                        <Popup trigger={<Icon name='sticky note' />} content={dateParam.Notes} />
                    </div>}
                </div>
            }
            <div className='date-other'>
                {viewSettings.showYield && yieldForDate && <div className='yield'>Y={yieldForDate.Level}</div>}
                {viewSettings.showOccupancy && availabilityForDate && <div className='occupancy'>{((1 - availabilityForDate.Occupancy) * 100).toFixed(0)}%</div>}
            </div>
        </div>
    );
};

export default ResourceDayCell;